/*
 *  I15MASVOLAPHUMLCalcul.ts
 *
 *  Created by Sébastien Hecart on 2022-05-29 21:26:16 +0000.
 *  Copyright © 2022 Sebastien Hecart - Fahbe Company - . All rights reserved.
 *
 */

import { I15MASVOLAPHUML_State } from '@batical/types/src'

function I15MASVOLAPHUML_docalcul(state: I15MASVOLAPHUML_State) {
  if (state.in_massVolApp === 0) {
    state.res_massVolBois = 0
    return state
  }
  state.res_massVolBois =
    ((100 - state.in_humiditeSouhaite) / (100 - state.in_humiditeRf)) * (state.in_massVolApp - 10 * state.in_humiditeRf) +
    10 * state.in_humiditeSouhaite
  return state
}

export default I15MASVOLAPHUML_docalcul
